<script>
import { mapState } from 'vuex';
import ContactForm from '../../components/contactForm.vue';
import FilterMenu from '../../components/filterMenu.vue';
import FilterTags from '../../components/filterTags.vue';
import GalleryInfo from '../../components/galleryInfo.vue';
import Picker from '../../components/picker.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "works",
    data() {
        return {
            artist: [],
            artistActiveIndex: [],
            category: [],
            categoryActiveIndex: [],
            list: [],
            page: 1,
            allPage: 1,
            isLoading: false,
            sort: [
                { value: 1, name: this.$t('sort[0]') },
                { value: 2, name: this.$t('sort[1]') },
                { value: 3, name: this.$t('sort[2]') },
            ],
            sortValue: 0,
            isShowFilter: false,
            isShowSort: false,
        };
    },
    computed: {
        ...mapState(['galleryHome'])
    },
    components: {
        FilterMenu,
        FilterTags,
        ContactForm,
        GalleryInfo,
        Picker,
        Loading
    },
    mounted() {
        this.getCategory();
        this.getList();
    },
    destroyed() {},
    watch: {
        sortValue: {
            handler: function () { 
                this.list = [];
                this.page = 1;
                this.allPage = 1;
                this.getList();
            }
        },
        '$route': {
            handler: function () { 
                this.list = [];
                this.page = 1;
                this.allPage = 1;
                this.getList();
            }
        },
    },
    methods: {
        getCategory() { 
            this.$store.dispatch('getGalleryCategory', {
                type: 4
            }).then((result) => {
                if (result.code == 100) { 
                    // 筛选
                    this.artist = [
                        { name: '艺术家', children: result.data.artist },
                    ]
                    this.category = result.data.category.map(v => {
                        return {
                            ...v,
                            children: [...v.item]
                        }
                    })

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                
            });
        },
        getCheckedIndex() {
            // 路由是否有艺术家id
            if (this.artist.length > 0) { 
                if (this.$route.query.artist) { 
                    // 找到对应的索引
                    let index = this.artist[0].children.findIndex(v => v.id == this.$route.query.artist);
                    if (index != -1) { 
                        // 找到了
                        this.artistActiveIndex = [index];
                    } else {
                        // 没找到
                        this.artistActiveIndex = [null];
                    }
                } else {
                    // 路由没有艺术家id
                    this.artistActiveIndex = [null];
                }
            }
            
            // 路由是否有筛选id
            if (this.category.length > 0) { 
                if (this.$route.query.id) { 
                    const ids = this.$route.query.id.split(',');
                    this.categoryActiveIndex = this.category.map((v, i) => {
                        const checked = v.children.findIndex(item => {
                            return ids.findIndex(v => v == item.id) != -1
                        })
                        return checked != -1 ? checked : null;
                    });
                } else {
                    // 路由没有筛选id
                    this.categoryActiveIndex = this.category.map(() => null);
                }
            }
        },
        getList() { 
            if (this.isLoading) { 
                return;
            }
            this.isLoading = true;
            this.$store.dispatch('getGalleryWorks', {
                artist_id: this.$route.query.artist ? this.$route.query.artist : '',
                category_ids: this.$route.query.id ? this.$route.query.id : '',
                limit: 9,
                page: this.page,
                sort: this.sort[this.sortValue].value,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.list = this.list.concat(result.data.list);
                    this.allPage = result.data.last_page;
                    
                    this.getCheckedIndex();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getList();
        },
        changeArtist(value) { 
            let query = {};
            if (value[0] != null) { 
                query.artist = `${this.artist[0].children[value[0]].id}`;
            }
            if (this.$route.query.id) { 
                query.id = this.$route.query.id;
            }
            this.$router.push({
                path: '/gallery/works',
                query
            })
        },
        changeCategory(value) { 
            let query = {};
            if (this.$route.query.artist) { 
                query.artist = this.$route.query.artist;
            }
            let arr = [];
            // 根据索引获取id数组
            value.forEach((v, i) => {
                if (v != null) { 
                    arr.push(this.category[i].children[v].id);
                }
            })
            const ids = arr.join(',');
            if (ids != '') { 
                query.id = ids;
            }
            this.$router.push({
                path: '/gallery/works',
                query
            })
        },
    },
};
</script>

<template>
    <div class="works">
        <div class="layout_body">
            <!-- banner -->
            <div class="banner">
                <div class="layout_bg" :style="`background-image: url(${galleryHome.work_banner});`"></div>
            </div>
            <div class="only_mobile">
                <div class="filter_tabs flex">
                    <div class="item" :class="{active: isShowFilter}" @click="isShowFilter = !isShowFilter">
                        <div class="name">筛选</div>
                    </div>
                    <div class="item" :class="{active: isShowSort}" @click="isShowSort = !isShowSort">
                        <div class="name">{{ sort[sortValue].name }}</div>
                    </div>
                </div>
                <template v-if="isShowFilter">
                    <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeArtist"/>
                    <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeCategory"/>
                </template>
                <div class="sort" v-if="isShowSort">
                    <div class="item" v-for="(item, index) in sort" :key="index" @click="sortValue = index">{{ item.name }}</div>
                </div>
            </div>
            <div class="layout_main">
                <div class="layout_content">
                    <p class="breadcrumb only_pc"><router-link to="/">A<sup>+</sup> Studio Gallery</router-link> / 作品总览</p>
                    <div class="tags flex justify_end align_center only_pc">
                        <Picker :data="sort" v-model="sortValue"/>
                    </div>
                    <div class="wrapper flex">
                        <div class="filter only_pc" v-if="artist.length > 0 || category.length > 0">
                            <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeArtist"/>
                            <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeCategory"/>
                        </div>
                        <div class="content">
                            <div class="list flex flex_wrap">
                                <router-link class="item" v-for="(item, index) in list" :key="index" :to="`/gallery/works/detail?id=${item.id}`">
                                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                    <p class="artist">{{ item.artist_name }}</p>
                                    <p class="name">{{ item.name }}</p>
                                    <p class="price" v-if="item.price == '0.00'">免费</p>
                                    <p class="price" v-else>RMB {{ item.price }}</p>
                                </router-link>
                            </div>
                            <Loading v-if="isLoading"/>
                            <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
                            <p class="no_more" v-else-if="page == allPage">已经到底了</p>
                            <div class="flex justify_end">
                                <div class="layout_btn_more" @click="getMore">更多作品</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ContactForm/>
        <GalleryInfo/>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.2rem;
    }
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
    }
}
.filter_tabs{
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    height: .7rem;
    .item{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #999;
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
        &:last-child{
            border-right: none;
        }
        .name{
            text-align: center;
        }
        &::after{
            content: "";
            display: block;
            width: .14rem;
            height: .14rem;
            border-right: 1px solid #999;
            border-bottom: 1px solid #999;
            transform: translate(0, -25%) rotate(45deg);
            margin-left: .2rem;
        }
    }
}
.sort{
    padding: .3rem .6rem;
    border-bottom: 1px solid #999;
    .item{
        line-height: .6rem;
        font-size: .32rem;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.tags{
    margin-bottom: .3rem;
}
.wrapper{
    gap: .5rem;
}
.content{
    flex: 1;
    .list{
        gap: .39rem;
        .item{
            width: 2.54rem;
            text-align: center;
            font-size: .2rem;
            line-height: 1.6;
            .cover{
                height: 0;
                padding-bottom: 100%;
                // border: 1px solid #666;
                margin-bottom: .2rem;
            }
        }
        @media only screen and (max-width: 750px) {
            gap: .3rem;
            .item{
                width: 3.3rem;
                font-size: .26rem;
            }
        }
    }
    .layout_btn_more{
        border-bottom: 1px solid #666;
        @media only screen and (max-width: 750px) {
            margin: .3rem auto 0;
        }
    }
}
</style>